module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Modern Havana1.f3a0be56.jpg";